export default __webpack_public_path__ + "static/media/fb.01407ddb.png";